import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getDistanceCaches } from '@/services/admin/distance-caches';
import type { DistanceCacheListParams } from '@/services/admin/distance-caches';
import useAppToast from '@/hooks/useAppToast';
import { getApiErrorMessage } from '@/utils/apiError';

export type { DistanceCacheListParams } from '@/services/admin/distance-caches';

export const useAdminDistanceCachesList = (
  site: string | null,
  params: DistanceCacheListParams
) => {
  const toast = useAppToast();

  const query = useQuery({
    queryKey: ['admin', 'distance-caches', site ?? '', params],
    queryFn: () => getDistanceCaches(site!, params),
    enabled: !!site,
    staleTime: 0,
  });

  useEffect(() => {
    if (query.isError && query.error) {
      toast.error(getApiErrorMessage(query.error, 'エラーが発生しました。'));
    }
  }, [query.isError, query.error, toast]);

  return query;
};
